module.exports = __webpack_public_path__ + "static/media/paytm.525cf722.png";